import {
  TBaseBulkDeleteResponseDto,
  TBaseCreateResponseDto,
  TBaseDeleteResponseDto, TBaseGetAllResponseDto, TBaseGetResponseDto, TBaseUpdateResponseDto
} from './common/t-base-response.dto';
import {AutoMap} from '@automapper/classes';
import {
  TBaseBulkDeleteRequestDto,
  TBaseCreateRequestDto, TBaseDeleteRequestDto,
  TBaseGetAllRequestDto,
  TBaseGetRequestDto,
  TBaseUpdateRequestDto
} from './common/t-base-request.dto';

export class HighlightGetAllRequestDto extends TBaseGetAllRequestDto {}
export class HighlightGetAllResponseDto extends TBaseGetAllResponseDto {
  @AutoMap()
  public sourceId!: string;

  @AutoMap()
  public sourceName!: string;

  @AutoMap()
  public text: string = '';

  @AutoMap()
  public isStarred: boolean = false;
}

export class HighlightGetRequestDto extends TBaseGetRequestDto {}
export class HighlightGetResponseDto extends TBaseGetResponseDto {
  @AutoMap()
  public sourceId!: string;

  @AutoMap()
  public sourceName!: string;

  @AutoMap()
  public text: string = '';

  @AutoMap()
  public description: string | null = null;

  @AutoMap()
  public priority!: string;

  @AutoMap()
  public quotedBy: string | null = null;

  @AutoMap()
  public isStarred: boolean = false;
}

export class HighlightCreateRequestDto extends TBaseCreateRequestDto {
  @AutoMap()
  public sourceId!: string;

  @AutoMap()
  public text: string = '';

  @AutoMap()
  public description: string | null = null;

  @AutoMap()
  public priority!: string;

  @AutoMap()
  public quotedBy: string | null = null;

  @AutoMap()
  public isStarred: boolean = false;
}
export class HighlightCreateResponseDto extends TBaseCreateResponseDto {}

export class HighlightUpdateRequestDto extends TBaseUpdateRequestDto {
  @AutoMap()
  public sourceId!: string;

  @AutoMap()
  public text: string = '';

  @AutoMap()
  public description: string | null = null;


  @AutoMap()
  public priority!: string;

  @AutoMap()
  public quotedBy: string | null = null;

  @AutoMap()
  public isStarred: boolean = false;
}
export class HighlightUpdateResponseDto extends TBaseUpdateResponseDto {}

export class HighlightDeleteRequestDto extends TBaseDeleteRequestDto {}
export class HighlightDeleteResponseDto extends TBaseDeleteResponseDto {}

export class HighlightBulkDeleteRequestDto extends TBaseBulkDeleteRequestDto {}
export class HighlightBulkDeleteResponseDto extends TBaseBulkDeleteResponseDto {}
